import {
  TIMESHEET_MYPROJECTS_DAY,
  TIMESHEET_MYPROJECTS_REVIEW,
} from "@/lib/utils";
import { format, isFuture } from "date-fns";

import { Link } from "react-router-dom";
import React from "react";
import { cn } from "utils";

const TimesheetReviewDayCell = ({ day }) => {
  const { events = [], isCurrentMonth, isToday } = day;
  const date = day.date;
  const dayNumber = format(date, "d");

  const isFutureDate = isFuture(date);

  // Calculate entries needing review and review status
  const entriesNeedingReview = events.filter((event) => {
    const approved = event.approved || 0;
    const unapproved = event.unapproved || 0;
    const totalReviewed = approved + unapproved;
    return event.hours && Math.abs(event.hours - totalReviewed) >= 0.01;
  });

  const hasEntriesNeedingReview = entriesNeedingReview.length > 0;
  const hasAnyEntries = events.length > 0;
  const isFullyReviewed = hasAnyEntries && entriesNeedingReview.length === 0;

  // Cell background color based on review status
  const cellClasses = cn(
    "relative h-24 p-3 border-b border-gray-200 hover:opacity-80",
    isFullyReviewed ? "bg-primary-foreground" : "bg-background", // Gray if fully reviewed, white otherwise
  );

  const renderDay = () => {
    return (
      <time
        dateTime={date}
        className={cn(
          "font-medium",
          isToday
            ? "flex h-6 w-6 items-center justify-center rounded-full bg-black text-white"
            : undefined,
          isFutureDate ? "text-muted-foreground" : "!text-base-foreground",
        )}
      >
        {dayNumber}
      </time>
    );
  };

  const renderFooter = () => {
    if (!hasAnyEntries) {
      return null; // No footer if no entries
    }

    if (isFullyReviewed) {
      return null;
    }

    if (hasEntriesNeedingReview) {
      return (
        <div className="mt-auto text-xs  font-medium">
          {entriesNeedingReview.length} Remaining
        </div>
      );
    }

    return null;
  };

  return (
    <Link
      to={!isFutureDate && `/${TIMESHEET_MYPROJECTS_DAY}/day?date=${day.date}`}
      className={cellClasses}
    >
      <div className="flex flex-col h-full justify-between">
        {renderDay()}
        {renderFooter()}
      </div>
    </Link>
  );
};

export default TimesheetReviewDayCell;
